import React, { useEffect, useState } from "react";
import { listDemos, downloadDemo } from '../../../store/auth';
import { LuPlay, LuDownload, LuFileText, LuVideo, LuExternalLink, LuRefreshCw, LuEye } from 'react-icons/lu';
import MediaModal from './MediaModal';
import { CACHED_FILE_BASE_URL } from '../../../commonConfig/ApiConfig';

const Demo = () => {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [downloadingId, setDownloadingId] = useState(null);
  
  // Modal state
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState({
    type: null,
    url: null,
    title: null,
    id: null
  });

  // Fetch all demos
  const fetchResources = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await listDemos();
      const demos = response.data?.demos || [];
      
      if (demos.length === 0) {
        setError("No demos found");
      }
      
      setResources(demos);
    } catch (err) {
      console.error("Error fetching demos:", err);
      setError(err.message || "Failed to fetch demos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResources();
  }, []);

  // Handle opening modal to view PDF/MP4
  const handleView = (item) => {
    let file_url = "";
    item.type === "youtube" ? file_url = item.file_url : file_url = `${CACHED_FILE_BASE_URL}` + item.file_url;
    setModalData({
      type: item.type,
      url: file_url,
      title: item.title,
      id: item.id
    });
    setModalOpen(true);
  };

  // Handle download for PDF/MP4 files
  const handleDownload = async (demoId, demoType, demoTitle) => {
    try {
      setDownloadingId(demoId);
      await downloadDemo(demoId, demoType, demoTitle);
    } finally {
      setDownloadingId(null);
    }
  };

  // Handle download from modal
  const handleModalDownload = async () => {
    await handleDownload(modalData.id, modalData.type, modalData.title);
  };

  // Extract YouTube video ID from URL
  const getYouTubeEmbedUrl = (url) => {
    if (!url) return "";
    const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&]+)/);
    return match ? `https://www.youtube.com/embed/${match[1]}` : "";
  };

  const cardStyle = {
    borderRadius: '16px',
    border: '2px solid #e2e8f0',
    transition: 'all 0.3s ease',
    backgroundColor: 'white',
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  };

  const handleCardHover = (e, isHovering) => {
    if (isHovering) {
      e.currentTarget.style.transform = 'translateY(-8px)';
      e.currentTarget.style.boxShadow = '0 12px 24px rgba(44, 82, 130, 0.15)';
      e.currentTarget.style.borderColor = '#5484c0';
    } else {
      e.currentTarget.style.transform = 'translateY(0)';
      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
      e.currentTarget.style.borderColor = '#e2e8f0';
    }
  };

  // Loading state
  if (loading) {
    return (
      <div style={{ backgroundColor: '#f8fbff', minHeight: '100vh', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
          <div style={{
            ...cardStyle,
            padding: '48px',
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}>
            <div style={{
              width: '48px',
              height: '48px',
              border: '4px solid #e2e8f0',
              borderTopColor: '#3182ce',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto 20px'
            }}></div>
            <p style={{ color: '#4a5568', fontSize: '1.125rem' }}>Loading resources...</p>
          </div>
        </div>
        
        <style>{`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // Error state
  if (error && resources.length === 0) {
    return (
      <div style={{ backgroundColor: '#f8fbff', minHeight: '100vh', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
          <div style={{
            ...cardStyle,
            padding: '48px',
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}>
            <div style={{
              width: '64px',
              height: '64px',
              backgroundColor: '#fef3c7',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              color: '#f59e0b',
              fontSize: '32px'
            }}>⚠️</div>
            <h3 style={{ color: '#2c5282', fontWeight: '600', marginBottom: '12px', fontSize: '1.5rem' }}>
              Coming Soon
            </h3>
            <p style={{ color: '#718096', marginBottom: '24px', lineHeight: '1.6' }}>
              {error}
            </p>
            {/* <button 
              onClick={fetchResources}
              style={{
                backgroundColor: '#3182ce',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2c5282'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#3182ce'}
            >
              <LuRefreshCw size={20} />
              Refesh
            </button> */}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#f8fbff', minHeight: '100vh', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>
      {/* Main Content */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '40px 20px' }}>
        
        {/* Introduction Card */}
        <div style={{ marginBottom: '40px' }}>
          <div style={{
            ...cardStyle,
            padding: 'clamp(24px, 4vw, 32px)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}
          onMouseEnter={(e) => handleCardHover(e, true)}
          onMouseLeave={(e) => handleCardHover(e, false)}>
            <h2 style={{ color: '#2c5282', fontWeight: '700', marginBottom: '16px', fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)' }}>
              Welcome to CDAP Resources
            </h2>
            <p style={{ color: '#4a5568', fontSize: 'clamp(0.95rem, 1.8vw, 1.125rem)', lineHeight: '1.7', margin: '0' }}>
              Access comprehensive learning materials including video tutorials, PDF guides, and step-by-step walkthroughs. 
              Whether you're new to CDAP or looking to explore advanced features, these resources will help you navigate 
              the platform effectively and unlock the full potential of urban data analytics.
            </p>
          </div>
        </div>

        {resources.length === 0 ? (
          <div style={{
            ...cardStyle,
            padding: '48px',
            textAlign: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}>
            <div style={{
              width: '64px',
              height: '64px',
              backgroundColor: '#dbeafe',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              color: '#3182ce',
              fontSize: '32px'
            }}>📚</div>
            <h3 style={{ color: '#2c5282', fontWeight: '600', marginBottom: '12px', fontSize: '1.5rem' }}>
              No Resources Available
            </h3>
            <p style={{ color: '#718096', margin: '0', lineHeight: '1.6' }}>
              Learning resources will appear here once they are added to the platform.
            </p>
          </div>
        ) : (
          <>
            {/* Resources Grid */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
              gap: '24px'
            }}>
              {resources.map((item) => (
                <div
                  key={item.id}
                  style={{
                    ...cardStyle,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                  }}
                  onMouseEnter={(e) => handleCardHover(e, true)}
                  onMouseLeave={(e) => handleCardHover(e, false)}
                >
                  {/* Media Section */}
                  <div style={{ position: 'relative', flexShrink: 0 }}>
                    {item.type === "youtube" && item.url ? (
                      <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                        <iframe
                          style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            border: 'none'
                          }}
                          src={getYouTubeEmbedUrl(item.url)}
                          title={item.title}
                          allowFullScreen
                        ></iframe>
                      </div>
                    ) : (
                      <div style={{ position: 'relative', height: '200px', overflow: 'hidden', backgroundColor: '#f1f5f9' }}>
                        {item.thumbnail_url ? (
                          <img
                            src={item.thumbnail_url}
                            alt={item.title}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover'
                            }}
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextElementSibling.style.display = 'flex';
                            }}
                          />
                        ) : null}
                        <div style={{
                          display: item.thumbnail_url ? 'none' : 'flex',
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#dbeafe',
                          gap: '12px'
                        }}>
                          {item.type === "pdf" ? (
                            <LuFileText size={64} style={{ color: '#3182ce', opacity: 0.6 }} />
                          ) : (
                            <LuVideo size={64} style={{ color: '#3182ce', opacity: 0.6 }} />
                          )}
                          <span style={{
                            color: '#1e40af',
                            fontWeight: '600',
                            fontSize: '0.875rem',
                            textAlign: 'center',
                            padding: '0 20px'
                          }}>
                            {item.type === "pdf" ? "PDF Document" : "Video Resource"}
                          </span>
                        </div>
                        <div style={{
                          position: 'absolute',
                          top: '12px',
                          right: '12px',
                          backgroundColor: 'rgba(0, 0, 0, 0.7)',
                          color: 'white',
                          padding: '6px 12px',
                          borderRadius: '20px',
                          fontSize: '0.875rem',
                          fontWeight: '600',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px'
                        }}>
                          {item.type === "pdf" ? <LuFileText size={16} /> : <LuVideo size={16} />}
                          {item.type?.toUpperCase()}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Content Section */}
                  <div style={{ padding: '24px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <h5 style={{
                      color: '#2c5282',
                      fontWeight: '600',
                      marginBottom: '12px',
                      fontSize: '1.125rem',
                      lineHeight: '1.4',
                      flex: 1
                    }}>
                      {item.title}
                    </h5>

                    {/* Action Buttons */}
                    {item.type !== "youtube" ? (
                      <div style={{ display: 'flex', gap: '12px' }}>
                        {/* View Button */}
                        <button
                          onClick={() => handleView(item)}
                          style={{
                            backgroundColor: '#3182ce',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '12px 20px',
                            fontSize: '1rem',
                            fontWeight: '600',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            transition: 'all 0.3s ease',
                            flex: 1
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#3182ce';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#3182ce';
                          }}
                        >
                          <LuEye size={20} />
                          View
                        </button>

                        {/* Download Button */}
                        {/* <button
                          onClick={() => handleDownload(item.id, item.type, item.title)}
                          disabled={downloadingId === item.id}
                          style={{
                            backgroundColor: downloadingId === item.id ? '#cbd5e0' : '#3182ce',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '12px 20px',
                            fontSize: '1rem',
                            fontWeight: '600',
                            cursor: downloadingId === item.id ? 'not-allowed' : 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            transition: 'all 0.3s ease',
                            flex: 1
                          }}
                          onMouseEnter={(e) => {
                            if (downloadingId !== item.id) {
                              e.currentTarget.style.backgroundColor = '#2c5282';
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (downloadingId !== item.id) {
                              e.currentTarget.style.backgroundColor = '#3182ce';
                            }
                          }}
                        >
                          {downloadingId === item.id ? (
                            <>
                              <div style={{
                                width: '16px',
                                height: '16px',
                                border: '3px solid rgba(255, 255, 255, 0.3)',
                                borderTopColor: 'white',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite'
                              }}></div>
                              Downloading...
                            </>
                          ) : (
                            <>
                              <LuDownload size={20} />
                              Download
                            </>
                          )}
                        </button> */}
                      </div>
                    ) : (
                      <button
                        onClick={() => window.open(item.url, '_blank')}
                        style={{
                          backgroundColor: '#3182ce',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '12px 20px',
                          fontSize: '1rem',
                          fontWeight: '600',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px',
                          transition: 'all 0.3s ease',
                          width: '100%'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2c5282'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#3182ce'}
                      >
                        <LuExternalLink size={20} />
                        Watch on YouTube
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Media Modal */}
      <MediaModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        mediaType={modalData.type}
        mediaUrl={modalData.url}
        title={modalData.title}
        onDownload={handleModalDownload}
        isDownloading={downloadingId === modalData.id}
      />

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default Demo;